import { fetchData } from "../../Helpers";

export function startWebSession(successCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/web/session",
    successCallback: (resObj) => {
      const sessionId = resObj.data.sessionId;
      if (sessionId) {
        sessionStorage.setItem("sId", sessionId);
      }
      if (successCallback) successCallback(resObj);
    },
    controller: controller,
    shouldThrowError: false,
  });
}

export function trackWebEvent(event, value, successCallback) {
  const controller = new AbortController();

  const payload = {
    event: {
      sessionId: sessionStorage.getItem("sId"),
      ident: event,
      value: JSON.stringify({ ...value, device: "web" }),
    },
  };

  return fetchData({
    endpoint: "/web/event",
    payload,
    successCallback,
    controller: controller,
    shouldThrowError: false,
  });
}
